export function prepareAddressBody(form, buttons) {
    let body = {
        name: form.name,
        surname: form.surname,
        email: form.email,
        phone: form.phone,
        country: form.country,
        street: form.street,
        city: form.city,
        zip: form.zip,
    }

    body.has_other_billing_address = buttons.isCompany
    body.is_company = buttons.isCompany

    if (buttons.isCompany) {
        body.billing_country = form.billing_country
        body.billing_street = form.billing_street
        body.billing_city = form.billing_city
        body.billing_zip = form.billing_zip
        body.ico = form.ico
        body.company = form.company
        body.dic = (form.dic)? form.dic : null
        body.ic_dph = (form.ic_dph)? form.dic : null
    }

    return body
}